import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '../base-component/base.component';

@Component({
	selector: 'app-menu-button',
	templateUrl: './menu-button.component.html',
	styleUrls: ['./menu-button.component.scss'],
	standalone: true,
	imports: [CommonModule],
})
export class MenuButtonComponent extends BaseComponent implements OnInit {
	@Input() shouldChangeToPositionInitial: boolean;

	shouldFillMainColor = ['home', 'dohot', 'dohot-bizoim', 'dohot-lekohot', 'dohot-motzarim', 'admin-manage-company', 'admin-reports-company', 'likut/warehouse/actions'];

	private _router = inject(Router);

	constructor() {
		super();
	}

	shouldUseMainColorFill = this.shouldFillMainColor.includes((this._router.url || '').replace('/', ''));

	ngOnInit(): void {
		document.documentElement.style.setProperty('--menu-button-main-color', 'var(--' + (this.shouldUseMainColorFill ? 'main' : 'secondary') + '-color)');
	}
}
